import Vue from 'vue'
import Router from 'vue-router'
import Home from '../../views/Home.vue'
import NewsList from "../../views/learn/NewsList";
import QuestionList from "../../views/learn/QuestionList";
import NewsDetail from "../../views/learn/NewsDetail";
import VideoList from "../../views/learn/VideoList";
import VideoDetail from "../../views/learn/VideoDetail";
import Index from "../../views/learn/Index";
import TopicList from "../../views/learn/TopicList"
import TopicVideoList from "../../views/learn/TopicVideoList";

import ExamList from "../../views/learn/ExamList";
import ExamResult from "../../views/learn/ExamResult";
import ExamDetail from "../../views/learn/ExamDetail";
import Examing from "../../views/learn/Examing";
import Point from "../../views/learn/Point";

export default  [
    {
      path: '/',
      name: 'Home',
      component: Home,
      meta: {noLogin: false, noVisit: false},
      children: [
        {
          path: 'Index',
          component: Index,
          name: 'Index'
        },
        {
          path: 'NewsList',
          component: NewsList,
          name: 'NewsList'
        },{
          path: 'QuestionList',
          component: QuestionList,
          name: 'QuestionList'
        },
        {
          path: 'NewsDetail',
          component: NewsDetail,
          name: 'NewsDetail'
        },
        {
          path: 'VideoList',
          component: VideoList,
          name: 'VideoList'
        },
        {
          path: 'VideoDetail',
          component: VideoDetail,
          name: 'VideoDetail'
        },
        {
          path: 'TopicList',
          component: TopicList,
          name: 'TopicList'
        },
        {
          path: 'TopicVideoList',
          component: TopicVideoList,
          name: 'TopicVideoList'
        },
        {
          path: 'ExamList',
          component:ExamList,
          name: 'ExamList'
        },
        {
          path: 'Examing',
          component:Examing,
          name: 'Examing'
        },
        {
          path: 'ExamResult',
          component:ExamResult,
          name: 'ExamResult'
        },
        {
          path: 'ExamDetail',
          component:ExamDetail,
          name: 'ExamDetail'
        },
        {
          path: 'Point',
          component:Point,
          name: 'Point'
        },
      ]
    }
  ]



// WEBPACK FOOTER //
// ./src/router/routes/index.js